export default __webpack_public_path__ + "static/media/stopwatch.39c06366.png";